//Detecting when sticky header is sticking
const stickyObserver = new IntersectionObserver((entries) => {
    // no intersection with screen
    if(entries[0].intersectionRatio === 0)
        document.querySelector(".ssnail-navigation-container").classList.add("ssnail-is-sticky");
    // fully intersects with screen
    else if(entries[0].intersectionRatio === 1)
        document.querySelector(".ssnail-navigation-container").classList.remove("ssnail-is-sticky");
}, { threshold: [0,1] });
const ssnailStickyTrigger = document.querySelector(".ssnail-sticky-trigger");
if (ssnailStickyTrigger !== null) {
    stickyObserver.observe(ssnailStickyTrigger);
}

//Scroll animations
const animationsObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('ssnail-animated');
        } else {
            if (!entry.target.classList.contains('ssnail-once')) {
                entry.target.classList.remove('ssnail-animated');
            }
        }
    });
}, { threshold: 0.31 });
const animatedElements = document.querySelectorAll('.ssnail-scroll-animation');
animatedElements.forEach((el) => animationsObserver.observe(el));